import { type ApiClientResponse, type EntityReferenceRailsRequestData, apiClient, routes } from 'common/services';
import type { VideoContentObjectDataObject } from 'models/service';

type UpdateVideoRequestData = {
  video: VideoData;
};

type VideoData = {
  cover_photo?: EntityReferenceRailsRequestData;
  featured_in_channels?: boolean;
  full?: { external_id?: string };
  html_content?: string;
  name?: string;
  price_option?: string;
  recorded_at?: string;
  show_in_channels?: boolean;
  tag_ids?: string[];
  text_content?: string;
  trailer?: { external_id?: string };
};

export const updateVideo = async ({ data, id }: { data: UpdateVideoRequestData; id: string }) =>
  apiClient.patch<VideoContentObjectDataObject, ApiClientResponse<VideoContentObjectDataObject>>(
    routes.videos.update(id),
    data,
  );
